module.exports = __webpack_public_path__ + "img/y1.f7698006.png";